/*
import React from "react";

const ProductCard = ({ product, onClick }) => (
  <div style={{ border:"1px solid #ccc", padding:"20px", margin:"10px", borderRadius:"10px" }}>
    <h2>{product.name}</h2>
    <button
      onClick={() => onClick(product)}
      style={{ padding:"10px 20px", background:"#28a745", color:"#fff", border:"none", borderRadius:"5px" }}
    >
      Buy Now
    </button>
  </div>
);

export default ProductCard; */




import React from "react";

const ProductCard = ({ product, onClick }) => (
  <div
    style={{
      border: "1px solid #ddd",
      borderRadius: "12px",
      padding: "20px",
      margin: "10px",
      width: "250px",
      textAlign: "center",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      transition: "transform 0.2s, box-shadow 0.2s",
      cursor: "pointer",
      backgroundColor: "#fff"
    }}
    onClick={() => onClick(product)}
    onMouseEnter={e => {
      e.currentTarget.style.transform = "translateY(-5px)";
      e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.2)";
    }}
    onMouseLeave={e => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
    }}
  >
    {/* Icon / Image */}
    <div style={{ fontSize: "50px", marginBottom: "15px" }}>
      {product.icon || "📦"} 
    </div>

    {/* Product Name */}
    <h3 style={{ fontSize: "18px", marginBottom: "10px" }}>{product.name}</h3>

    {/* Product Description */}
    <p style={{ fontSize: "14px", color: "#555", minHeight: "40px" }}>
      {product.description || "Best insurance plan."}
    </p>

    {/* Buy Now Button */}
    <button
      style={{
        padding: "10px 20px",
        background: "#28a745",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        fontWeight: 600,
        fontSize: "14px",
        marginTop: "10px",
        cursor: "pointer"
      }}
    >
      Buy Now
    </button>
  </div>
);

export default ProductCard;
